import styled from "styled-components";
// import Theme from "../../Styles/Themes";
// import config from '../../Config/config.json';
// import SVG from "react-inlinesvg";

export const Container = styled.div`
    display: flex;
    width: 150px;
    justify-content: center;
    align-items: ${props => props.$aling ? props.$aling : 'center;'};
    flex-direction: column;
`;

export const ContainerInput = styled.div`
    position: relative;
    display: flex;
    width: 100%;
    border-radius: 10px;
    padding: 2px 12px 2px 12px;
    justify-content: flex-start;
    align-items: center;
    gap: 8px;

`;

export const CheckboxInput = styled.input.attrs({ type: 'checkbox' })`
    position: absolute;
    opacity: 0;
`;

export const CheckboxMark = styled.span`
    display: inline-block;
    width: 18px;
    height: 18px;
    border: 2px solid #33CC99;
    border-radius: 4px;
    background-color: ${props => (props.checked ? '#33CC99' : 'transparent')};
    cursor: pointer;
    position: relative;

    &:after {
        content: ${props => (props.checked ? "'\\2714'" : "''")};
        font-size: 14px;
        color: white;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: ${props => (props.checked ? 'block' : 'none')};
    }
`;

export const Text = styled.label` 
    width: 80%;
    color: #333;
    leading-trim: both;
    text-edge: cap;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    overflow-x: auto;
    &::-webkit-scrollbar {
        height : 3px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: #ccc;
        border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background-color: #aaa
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-button {
        display: none;
    }
`;